export const FETCH_PET = "FETCH_PET";
export const FETCH_PET_DATA = "FETCH_PET_ALL_DATA";

export const FETCH_PET_MODAL = "FETCH_PET_MODAL";
export const FETCH_PET_KIND_ID = "FETCH_PET_KIND_ID";

